const levels = {
  none: -1,
  trace: 0,
  debug: 1,
  info: 2,
  warn: 3,
  error: 4,
  critical: 5,
}

export class Logger {
  static logLevel = levels.info
  static groupSeparator = ' > '
  private _enabled = true
  private subheader?: string
  private parent?: Logger

  constructor(
    private header: string,
    {
      subheader,
      parent,
    }: {
      subheader?: string
      parent?: Logger
    } = {},
  ) {
    this.subheader = subheader
    this.parent = parent
  }

  static setLogLevel(level: keyof typeof levels) {
    Logger.logLevel = levels[level]
  }

  get prefix() {
    const sub = this.subheader ? `${Logger.groupSeparator}${this.subheader}` : ''

    return `[${this.header}${sub}]`
  }

  get enabled() {
    let { parent } = this
    while (parent) {
      if (!parent.enabled) return false

      parent = parent.parent
    }

    return this._enabled
  }

  enable() {
    this._enabled = true
  }

  disable() {
    this._enabled = false
  }

  group(subheader: string) {
    return new Logger(this.header, {
      subheader,
      parent: this,
    })
  }

  trace(...data: any[]) {
    if (!this.enabled || Logger.logLevel > levels.trace) return
    console.trace(this.prefix, ...data)
  }

  debug(...data: any[]) {
    if (!this.enabled || Logger.logLevel > levels.debug) return
    console.debug(this.prefix, ...data)
  }

  info(...data: any[]) {
    if (!this.enabled || Logger.logLevel > levels.info) return
    console.info(this.prefix, ...data)
  }

  warn(...data: any[]) {
    if (!this.enabled || Logger.logLevel > levels.warn) return
    console.warn(this.prefix, ...data)
  }

  error(...data: any[]) {
    if (!this.enabled || Logger.logLevel > levels.error) return
    console.error(this.prefix, ...data)
  }

  critical(...data: any[]) {
    if (!this.enabled || Logger.logLevel > levels.critical) return
    console.error(this.prefix, ...data)
  }
}
